<template>
    <div class="reviews">

        <div :class="'cont ' +
        ' type' +
        type +
        ' ' +
        color +
        (compact_version == 1 ? ' smaller_version ' : '')
        ">
        <h1 :class="compact_version == 1 ? 'smaller_version' : ''">
            {{ $t("recenzie") }}
        </h1>
        <div :class="compact_version == 1 ? 'reviews smaller_version' : 'reviews'
            " :style="filter[1] ? '' : 'justify-content: center;'">
            <svg class="uvodzovky" width="132" height="103" viewBox="0 0 132 103" fill="none">
                <g opacity="0.02">
                    <path
                        d="M32.2198 47.5743C27.5116 47.5904 22.8867 48.8317 18.7902 51.1788C24.5576 36.0816 34.1232 22.7692 46.5403 12.5588C47.2508 11.9671 47.839 11.2397 48.2715 10.4181C48.704 9.59649 48.9722 8.69679 49.0609 7.77035C49.1495 6.84392 49.0569 5.9089 48.7882 5.01868C48.5195 4.12845 48.0801 3.30046 47.495 2.58198C46.91 1.8635 46.1907 1.26859 45.3783 0.831224C44.5658 0.393863 43.6762 0.122612 42.7601 0.0329574C41.844 -0.0566975 40.9195 0.0370034 40.0392 0.308704C39.1589 0.580405 38.3402 1.02478 37.6298 1.61648C12.171 22.5356 0.841797 51.5006 0.841797 69.4589C0.885663 75.8086 2.75674 82.0081 6.22659 87.3002C9.69643 92.5924 14.6149 96.7484 20.3814 99.2607C24.1134 101.089 28.2004 102.056 32.3471 102.093C35.997 102.272 39.6449 101.7 43.0696 100.411C46.4944 99.1223 49.6246 97.1433 52.2705 94.5944C54.9164 92.0455 57.0228 88.9797 58.4621 85.5829C59.9014 82.1861 60.6436 78.5291 60.6436 74.8335C60.6436 71.138 59.9014 67.481 58.4621 64.0842C57.0228 60.6874 54.9164 57.6216 52.2705 55.0727C49.6246 52.5237 46.4944 50.5448 43.0696 49.2559C39.6449 47.9669 35.997 47.3948 32.3471 47.5743H32.2198Z"
                        fill="white" />
                    <path
                        d="M102.962 47.7756C98.2425 47.7859 93.6063 49.026 89.5033 51.3754C95.2807 36.3141 104.841 23.0239 117.249 12.8069C118.025 12.2428 118.679 11.5244 119.17 10.6961C119.661 9.86779 119.978 8.947 120.103 7.99042C120.227 7.03383 120.156 6.06168 119.894 5.13381C119.632 4.20594 119.184 3.34198 118.578 2.59508C117.972 1.84819 117.221 1.23417 116.37 0.790818C115.52 0.347465 114.589 0.0841611 113.634 0.017102C112.679 -0.0499571 111.72 0.0806497 110.817 0.400889C109.914 0.721128 109.086 1.22422 108.383 1.87921C82.8699 22.7704 71.5166 51.6968 71.5166 69.6311C71.5468 75.9005 73.3672 82.0286 76.7603 87.2834C80.1535 92.5382 84.9758 96.6975 90.6514 99.2645C94.4861 101.144 98.6975 102.111 102.962 102.093C106.619 102.272 110.275 101.701 113.707 100.413C117.139 99.1263 120.276 97.15 122.927 94.6045C125.579 92.059 127.69 88.9972 129.132 85.605C130.575 82.2127 131.318 78.5606 131.318 74.87C131.318 71.1794 130.575 67.5272 129.132 64.1349C127.69 60.7427 125.579 57.681 122.927 55.1355C120.276 52.59 117.139 50.6137 113.707 49.3265C110.275 48.0392 106.619 47.4679 102.962 47.6471V47.7756Z"
                        fill="white" />
                </g>
            </svg>
            <div v-if="filter[1]" @click="back(filter[showReview])" class="left">
                <svg width="11" height="20" viewBox="0 0 11 20" fill="none">
                    <path d="M9.95923 1.875L1.64008 10.1L9.95923 18.325" stroke="white" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
            <div v-for="review in filter" :key="review.id" v-show="filter[showReview] == review" class="review">
                <p>
                    {{ review.text }}
                </p>
                <div class="name">
                    <b>{{ review.klient }}</b><br />
                    {{ review.osoba }}
                </div>
                <div v-if="filter[1]" class="slide">
                    <span v-for="r in filter" :key="r.id" :class="{ active: r.id == review.id }" :style="r.id == review.id
                            ? 'background-color: ' + new_color + ';'
                            : ''
                        " @click="current(r.id)"></span>
                </div>
            </div>
            <div v-if="filter[1]" @click="next(filter[showReview])" class="right">
                <svg width="11" height="20" viewBox="0 0 11 20" fill="none">
                    <path d="M1.24341 1.875L9.56256 10.1L1.24341 18.325" stroke="white" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    props: ["items", "color", "new_color", "type", "compact_version"],
    data() {
        return {
            showReview: 0,
            reviews: [],
        };
    },
    created() {
        this.reviews = this.items;
    },
    methods: {
        current(id) {
            var i = 0;
            this.reviews.forEach((review) => {
                if (review.id == id) this.showReview = i;
                i++;
            });
        },
        next(review) {
            const currentIndex = this.reviews.indexOf(review);
            const nextIndex = (currentIndex + 1) % this.reviews.length;
            this.showReview = nextIndex;
        },
        back(review) {
            if (this.reviews[0] != review) {
                const currentIndex = this.reviews.indexOf(review);
                const nextIndex = (currentIndex - 1) % this.reviews.length;
                this.showReview = nextIndex;
            } else {
                this.showReview = this.reviews.length - 1;
            }
        },
    },
    computed: {
        filter() {
            var items = [];
            this.reviews.forEach((review) => {
                if (review.active == 1) items.push(review);
            });
            return items;
        },
    },
};
</script>

<style lang="scss" scoped>
.reviews {
    .cont {
        &.type2 {
            background: #f1eee8;
        }

        &.type3 {
            background: #f6f9fd;
        }

        &.type4 {
            background: #ecf1f6;
        }

        &.type5 {
            background: #fffdf5;
        }

        &.type7,
        &.type10 {
            background: #ffffff;
        }

        font-family: "Montserrat",
        sans-serif;
        position: relative;
        width: 100%;
        height: auto;
        padding-bottom: 20px;
        margin-bottom: 75px;

        &.smaller_version {
            margin-bottom: 40px;
        }

        @media only screen and (max-width: 900px) {
            height: auto;
            padding-bottom: 30px;
            margin-bottom: 50px;
        }

        h1 {
            font-style: normal;
            font-weight: 800;
            font-size: 72px;
            line-height: 112.5%;
            text-align: center;
            transform: translateY(-25px);

            @media only screen and (max-width: 900px) {
                font-size: 50px;
            }

            @media only screen and (max-width: 500px) {
                font-size: 40px;
            }

            &.smaller_version {
                text-align: center;
                font-size: 48px;
                font-style: normal;
                font-weight: 800;
                line-height: 112.5%;
                /* 54px */
                transform: translateY(25px);
            }
        }

        svg.uvodzovky {
            pointer-events: none;
            position: absolute;
            left: 32px;
            top: 20%;
        }

        .reviews {
            position: relative;
            width: 1200px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;

            @media only screen and (max-width: 1200px) {
                width: 950px;
            }

            @media only screen and (max-width: 900px) {
                width: 92%;
            }

            .left svg,
            .right svg {
                margin-top: 50px;
                cursor: pointer;
            }

            &.smaller_version {
                .review {
                    margin-top: 30px;
                }
            }

            .review {
                text-align: center;

                p {
                    width: 930px;

                    @media only screen and (max-width: 1200px) {
                        width: 80%;
                        margin: 0 auto;
                        margin-bottom: 45px;
                    }

                    @media only screen and (max-width: 900px) {
                        text-align: center;
                    }

                    font-style: normal;
                    font-weight: 300;
                    font-size: 16px;
                    line-height: 183.5%;
                    margin-bottom: 45px;
                }

                .name {
                    width: max-content;
                    margin: 0 auto;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 142.5%;
                    margin-bottom: 17px;
                }

                .slide {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                        cursor: pointer;
                        width: 10.11px;
                        height: 3px;
                        border-radius: 3px;
                        opacity: 0.1;
                        margin-right: 6px;
                    }

                    span.active {
                        opacity: 1;
                    }
                }
            }
        }
    }

    .black {
        background: linear-gradient(0deg, #0f1615, #0f1615), #ffffff;

        h1 {
            color: rgba(255, 255, 255, 0.05);
        }

        .reviews {

            .left svg path,
            .right svg path {
                stroke: #fff;
            }

            .review {
                p {
                    color: #ffffff;
                }

                .name {
                    color: #ffffff;
                }

                .slide {
                    span {
                        background: #e6e6e6;
                    }
                }
            }
        }
    }

    .type5.white {
        .reviews {

            .left svg path,
            .right svg path {
                stroke: #1b4524;
            }

            .review {
                p {
                    color: #1b4524;
                }

                .name {
                    color: #1b4524;
                }
            }
        }
    }

    .white {
        background: linear-gradient(0deg, #f7f8f8, #f7f8f8), #ffffff;

        h1 {
            color: rgba(33, 37, 65, 0.05);
        }

        svg.uvodzovky g path {
            fill: #000;
        }

        .reviews {

            .left svg path,
            .right svg path {
                stroke: #263544;
            }

            .review {
                p {
                    color: #212541;
                }

                .name {
                    color: #212541;
                }

                .slide {
                    span {
                        background: #e6e6e6;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .homesystem {
        background: #ecf1f6;

        h1 {
            color: rgba(33, 37, 65, 0.05);
        }

        svg.uvodzovky g path {
            fill: #000;
        }

        .reviews {

            .left svg path,
            .right svg path {
                stroke: #263544;
            }

            .review {
                p {
                    color: #212541;
                }

                .name {
                    color: #212541;
                }

                .slide {
                    span {
                        background: #e6e6e6;
                        opacity: 1;
                    }
                }
            }
        }
    }
}
</style>
